import React from 'react'
import { useAuthStore } from '../../../../store/authStore'
import FacilitationForm from './Create'

const FacilitationFormMain: React.FC = () => {
  const user = useAuthStore((state) => state.userData)

  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center h-64 space-y-4">
        <svg
          className="animate-spin h-10 w-10 text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
        <p className="text-lg font-medium text-gray-700">Not Authenticated</p>
        <p className="text-sm text-gray-500">Please log in to view the form</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center mt-10">
      <FacilitationForm />
    </div>
  )
}

export default FacilitationFormMain
